import React from 'react';
import {
  MoreVertical,
  Eye,
  Edit,
  Copy,
  CheckCircle,
  X,
  DollarSign,
  Download,
  Trash2,
  Link2,
  Send,
} from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export const AdminPropertyActionsMenu = ({
  property,
  busyManageLinkFor,
  busyResendFor,
  onOpenPreview,
  onEditData,
  onClone,
  onPublish,
  onViewSite,
  onEditPublicationUrl,
  onUnpublish,
  onRegisterPayment,
  onEditPayment,
  onUnmarkPaid,
  onGenerateZip,
  onCopyManageLink,
  onResendManageLink,
  onDelete,
}) => {
  const isPublished = Boolean(property.publication?.published);
  const isPaid = Boolean(property.payment?.paid);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <MoreVertical className="h-4 w-4 mr-2" />
          Acciones
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel>Navegacion</DropdownMenuLabel>
        <DropdownMenuItem onSelect={onOpenPreview}>
          <Eye className="h-4 w-4" />
          Ver preview
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuLabel>Contenido</DropdownMenuLabel>
        <DropdownMenuItem onSelect={onEditData}>
          <Edit className="h-4 w-4" />
          Editar datos
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onClone}>
          <Copy className="h-4 w-4" />
          Clonar
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuLabel>Publicacion</DropdownMenuLabel>
        {isPaid && !isPublished && (
          <DropdownMenuItem onSelect={onPublish}>
            <CheckCircle className="h-4 w-4" />
            Publicar
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={onGenerateZip} disabled={!isPaid}>
          <Download className="h-4 w-4" />
          Generar ZIP
        </DropdownMenuItem>
        {isPublished && (
          <>
            <DropdownMenuItem onSelect={onViewSite}>
              <Eye className="h-4 w-4" />
              Ver sitio
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={onEditPublicationUrl}>
              <Edit className="h-4 w-4" />
              Editar URL de publicacion
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={onUnpublish} className="text-red-600 focus:text-red-700">
              <X className="h-4 w-4" />
              Desmarcar publicado
            </DropdownMenuItem>
          </>
        )}

        <DropdownMenuSeparator />
        <DropdownMenuLabel>Solicitudes y Enlaces</DropdownMenuLabel>
        <DropdownMenuItem
          onSelect={onCopyManageLink}
          disabled={!isPublished || busyManageLinkFor === property.license_number}
        >
          <Link2 className="h-4 w-4" />
          {busyManageLinkFor === property.license_number ? 'Cargando enlace...' : 'Copiar enlace privado'}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={onResendManageLink}
          disabled={!isPublished || busyResendFor === property.license_number}
        >
          <Send className="h-4 w-4" />
          {busyResendFor === property.license_number ? 'Enviando enlace...' : 'Reenviar enlace al cliente'}
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuLabel>Pago</DropdownMenuLabel>
        {!isPaid ? (
          <DropdownMenuItem onSelect={onRegisterPayment}>
            <DollarSign className="h-4 w-4" />
            Registrar pago
          </DropdownMenuItem>
        ) : (
          <>
            <DropdownMenuItem onSelect={onEditPayment}>
              <Edit className="h-4 w-4" />
              Editar pago
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={onUnmarkPaid} className="text-red-600 focus:text-red-700">
              <X className="h-4 w-4" />
              Desmarcar pagado
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onDelete} className="text-red-600 focus:text-red-700">
          <Trash2 className="h-4 w-4" />
          Eliminar propiedad
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
